import React from 'react';
import './style.scss';
import { IconColor, IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { IssuanceDocumentFileInfo } from 'views/utils/graphql/graphql';
import { ListItem } from 'views/mutual/list';
import { icons } from 'constants/icons';

type IssuanceDocumentFileListItemProps = {
  itemIndex: number;
  file: IssuanceDocumentFileInfo;
  selected: boolean;
  onSelect: (file: IssuanceDocumentFileInfo) => void;
  download: (file: IssuanceDocumentFileInfo) => void;
};

const IssuanceDocumentFileListItem: React.FC<IssuanceDocumentFileListItemProps> = ({
  itemIndex,
  file,
  selected,
  onSelect,
  download,
}: IssuanceDocumentFileListItemProps) => {
  return (
    <ListItem itemIndex={itemIndex} className="documentBody">
      <div className="documentBody_download">
        <input type="checkbox" onClick={() => onSelect(file)} checked={selected} />
      </div>
      <div className="documentBody_title">
        <SvgIcon icon={icons.file} size={IconSize.icon_s} color={IconColor.primary} />
        <a href={void 0} onClick={() => download(file)}>
          {file.DisplayName}
        </a>
      </div>
      <div className="documentBody_date">{file.IssueDate}</div>
    </ListItem>
  );
};

export type DocumentListProps = {
  items: Array<IssuanceDocumentFileInfo | null>;
  selectedItems: Array<IssuanceDocumentFileInfo>;
  onSelect: (file: IssuanceDocumentFileInfo) => void;
  download: (file: IssuanceDocumentFileInfo) => void;
};

export const IssuanceDocumentFileList = ({ items, selectedItems, onSelect, download }: DocumentListProps) => {
  return (
    <>
      {items
        ?.filter((x) => (x ? true : false))
        .map((item, index) => (
          <IssuanceDocumentFileListItem
            key={item?.ID}
            itemIndex={index}
            file={item!}
            onSelect={onSelect}
            download={download}
            selected={selectedItems.some((x) => x.ID === item?.ID)}
          />
        ))}
    </>
  );
};
